/* src/app/components/companies-components/companies-new-company-dashboard/companies-new-company-dashboard.component.scss */
/*# sourceMappingURL=companies-new-company-dashboard.component.css.map */
